import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import { FaCheckCircle, FaChartLine, FaMoneyBillWave, FaClipboardList, FaUsers, FaLightbulb, FaBalanceScale, FaFileInvoiceDollar } from 'react-icons/fa'
import PageHero from '../../components/PageHero/PageHero'

const OutsourcedAccounting = () => {
  return (
    <>
      <Helmet>
        <title>Outsourced Accounting & CFO Services - Proof of Reserves Auditor</title>
        <meta name="description" content="Comprehensive outsourced accounting and fractional CFO services for cryptocurrency and digital asset companies." />
      </Helmet>

      <div className="service-page">
        <PageHero
          title="Outsourced Accounting & CFO Services"
          description="Full-service accounting and strategic financial leadership for crypto companies at any stage"
        >
          <div className="flex flex-wrap gap-6 mb-8 justify-center">
            <div className="flex items-center space-x-2">
              <FaCheckCircle className="text-accent" />
              <span>Crypto-Native Accountants</span>
            </div>
            <div className="flex items-center space-x-2">
              <FaCheckCircle className="text-accent" />
              <span>Scalable Solutions</span>
            </div>
            <div className="flex items-center space-x-2">
              <FaCheckCircle className="text-accent" />
              <span>Strategic Financial Guidance</span>
            </div>
          </div>
          <Link to="/contact" className="btn-primary bg-accent hover:bg-accent-dark">
            Get Started
          </Link>
        </PageHero>

        {/* Overview Section */}
        <section className="section-padding bg-white">
          <div className="container-custom max-w-4xl">
            <h2 className="section-title">Overview</h2>
            <p className="text-lg text-gray-600 mb-6">
              Managing accounting and financial operations for a cryptocurrency business requires specialized expertise and systems. Our outsourced accounting and fractional CFO services provide you with experienced crypto-native financial professionals without the overhead of full-time hires.
            </p>
            <p className="text-lg text-gray-600">
              From day-to-day bookkeeping to strategic financial planning, we deliver comprehensive support tailored to your business stage and needs. Our team understands digital asset accounting, blockchain transaction reconciliation, and the unique financial reporting requirements of crypto companies.
            </p>
          </div>
        </section>

        {/* Service Tiers */}
        <section className="section-padding bg-gray-50">
          <div className="container-custom">
            <h2 className="section-title text-center mb-12">Comprehensive Service Offerings</h2>
            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white p-8 rounded-lg shadow-md">
                <FaClipboardList className="text-5xl text-accent mb-4" />
                <h3 className="text-2xl font-bold mb-4 text-primary">Bookkeeping & Accounting</h3>
                <p className="text-gray-600 mb-6">
                  Complete accounting operations from transaction recording to financial statement preparation.
                </p>
                <ul className="space-y-3 text-sm text-gray-600">
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Monthly financial close process</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>General ledger maintenance</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Accounts payable/receivable</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Bank & wallet reconciliation</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Crypto transaction tracking</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Monthly financial statements</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-lg shadow-md border-2 border-accent">
                <div className="bg-accent text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-4">
                  MOST POPULAR
                </div>
                <FaChartLine className="text-5xl text-accent mb-4" />
                <h3 className="text-2xl font-bold mb-4 text-primary">Controller Services</h3>
                <p className="text-gray-600 mb-6">
                  Strategic accounting oversight with financial analysis and reporting.
                </p>
                <ul className="space-y-3 text-sm text-gray-600">
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>All bookkeeping services included</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Financial analysis & insights</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Budget vs. actual reporting</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>KPI dashboard development</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Internal controls implementation</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Audit coordination support</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white p-8 rounded-lg shadow-md">
                <FaUsers className="text-5xl text-accent mb-4" />
                <h3 className="text-2xl font-bold mb-4 text-primary">Fractional CFO</h3>
                <p className="text-gray-600 mb-6">
                  Executive-level financial strategy and leadership on a part-time basis.
                </p>
                <ul className="space-y-3 text-sm text-gray-600">
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>All controller services included</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Strategic financial planning</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Fundraising support</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Board presentation materials</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Financial modeling & forecasting</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>M&A transaction support</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Specialized Capabilities */}
        <section className="section-padding bg-white">
          <div className="container-custom">
            <h2 className="section-title text-center mb-12">Crypto-Specific Accounting Expertise</h2>
            <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
              <div className="border-l-4 border-accent pl-6">
                <h3 className="text-xl font-bold mb-3 text-primary">Digital Asset Accounting</h3>
                <p className="text-gray-600 mb-4">
                  Specialized expertise in cryptocurrency accounting including:
                </p>
                <ul className="text-gray-600 space-y-2 text-sm">
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Multi-wallet tracking and reconciliation</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Token valuation methodologies</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>DeFi transaction classification</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Revenue recognition for crypto models</span>
                  </li>
                </ul>
              </div>

              <div className="border-l-4 border-accent pl-6">
                <h3 className="text-xl font-bold mb-3 text-primary">Treasury Management</h3>
                <p className="text-gray-600 mb-4">
                  Strategic management of your crypto and fiat treasuries:
                </p>
                <ul className="text-gray-600 space-y-2 text-sm">
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Cash flow forecasting and management</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Treasury diversification strategies</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Risk management and hedging</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Yield optimization strategies</span>
                  </li>
                </ul>
              </div>

              <div className="border-l-4 border-accent pl-6">
                <h3 className="text-xl font-bold mb-3 text-primary">Financial Systems Implementation</h3>
                <p className="text-gray-600 mb-4">
                  Setup and optimization of accounting technology:
                </p>
                <ul className="text-gray-600 space-y-2 text-sm">
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Accounting software selection and setup</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Crypto transaction tracking tools</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Automated reconciliation systems</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Financial reporting dashboards</span>
                  </li>
                </ul>
              </div>

              <div className="border-l-4 border-accent pl-6">
                <h3 className="text-xl font-bold mb-3 text-primary">Investor & Board Reporting</h3>
                <p className="text-gray-600 mb-4">
                  Professional reporting for stakeholders:
                </p>
                <ul className="text-gray-600 space-y-2 text-sm">
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Monthly investor update packages</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Quarterly board presentations</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>KPI tracking and analysis</span>
                  </li>
                  <li className="flex items-start">
                    <FaCheckCircle className="text-accent mt-1 mr-2 flex-shrink-0" />
                    <span>Variance analysis and commentary</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* CFO Services Detail */}
        <section className="section-padding bg-gray-50">
          <div className="container-custom max-w-4xl">
            <h2 className="section-title">Fractional CFO Strategic Services</h2>
            <div className="space-y-4">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex items-start space-x-4">
                  <FaMoneyBillWave className="text-3xl text-accent mt-1" />
                  <div>
                    <h3 className="font-bold text-lg mb-2 text-primary">Fundraising & Capital Strategy</h3>
                    <p className="text-gray-600">
                      Support for all aspects of fundraising including financial modeling, investor materials preparation, due diligence coordination, and cap table management.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex items-start space-x-4">
                  <FaLightbulb className="text-3xl text-accent mt-1" />
                  <div>
                    <h3 className="font-bold text-lg mb-2 text-primary">Strategic Planning & Budgeting</h3>
                    <p className="text-gray-600">
                      Annual budgeting, three-year strategic plans, scenario analysis, and ongoing financial forecasting to guide business decisions.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex items-start space-x-4">
                  <FaBalanceScale className="text-3xl text-accent mt-1" />
                  <div>
                    <h3 className="font-bold text-lg mb-2 text-primary">Mergers & Acquisitions</h3>
                    <p className="text-gray-600">
                      Financial due diligence, deal structuring, valuation analysis, and integration planning for M&A transactions.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-md">
                <div className="flex items-start space-x-4">
                  <FaFileInvoiceDollar className="text-3xl text-accent mt-1" />
                  <div>
                    <h3 className="font-bold text-lg mb-2 text-primary">Unit Economics & Profitability Analysis</h3>
                    <p className="text-gray-600">
                      Deep analysis of business economics, pricing strategies, customer acquisition costs, and paths to profitability.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Benefits */}
        <section className="section-padding bg-white">
          <div className="container-custom">
            <h2 className="section-title text-center mb-12">Why Outsource Your Accounting & CFO Functions?</h2>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-xl font-bold mb-3 text-primary">Cost Efficiency</h3>
                <p className="text-gray-600">
                  Access senior-level expertise at a fraction of the cost of full-time hires, with no benefits, equipment, or overhead expenses.
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-xl font-bold mb-3 text-primary">Crypto Specialization</h3>
                <p className="text-gray-600">
                  Our team specializes in digital asset accounting and understands the unique challenges of crypto businesses.
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-xl font-bold mb-3 text-primary">Scalability</h3>
                <p className="text-gray-600">
                  Scale services up or down as your business evolves, from startup to growth stage to mature operations.
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-xl font-bold mb-3 text-primary">Immediate Impact</h3>
                <p className="text-gray-600">
                  No ramp-up time or training required. Our experienced team delivers value from day one.
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-xl font-bold mb-3 text-primary">Technology Enabled</h3>
                <p className="text-gray-600">
                  Leverage modern cloud-based accounting systems and crypto-specific tools for efficient operations.
                </p>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-xl font-bold mb-3 text-primary">Focus on Core Business</h3>
                <p className="text-gray-600">
                  Free your team to focus on product development and growth while we handle financial operations.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Who We Serve */}
        <section className="section-padding bg-gray-50">
          <div className="container-custom">
            <h2 className="section-title text-center mb-12">Who We Serve</h2>
            <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-bold mb-3 text-accent">Early-Stage Startups</h3>
                <p className="text-gray-600">
                  Get your accounting right from the start with proper chart of accounts, financial systems, and processes that scale with your growth.
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-bold mb-3 text-accent">Growth-Stage Companies</h3>
                <p className="text-gray-600">
                  Navigate rapid growth with controller-level oversight, sophisticated reporting, and strategic financial guidance.
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-bold mb-3 text-accent">Funded Companies</h3>
                <p className="text-gray-600">
                  Meet investor reporting requirements and board expectations with professional financial management and strategic CFO support.
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg shadow-md">
                <h3 className="text-xl font-bold mb-3 text-accent">DeFi Protocols & DAOs</h3>
                <p className="text-gray-600">
                  Specialized accounting for decentralized organizations including treasury management, tokenomics, and contributor compensation.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="section-padding bg-gradient-to-br from-primary to-primary-dark text-white">
          <div className="container-custom text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Ready to Elevate Your Financial Operations?
            </h2>
            <p className="text-xl mb-8 max-w-2xl mx-auto">
              Schedule a consultation to discuss how our outsourced accounting and CFO services can support your business growth.
            </p>
            <Link to="/contact" className="btn-primary bg-accent hover:bg-accent-dark">
              Schedule Consultation
            </Link>
          </div>
        </section>
      </div>
    </>
  )
}

export default OutsourcedAccounting